'use strict';

import dashboardService from './maintenance/dashboard.service';
import companyService from './maintenance/company.service';
import globalconfigService from './maintenance/globalconfig.service'
import billingService from './maintenance/billing.service';
import userdataService from './maintenance/userdata.service';
import manualcleansingService from './maintenance/manualcleansing.service';
import newsfeedmasterService from './maintenance/newsfeedmaster.service';
const state = {}

const actions = {
  ...dashboardService.actions,
  ...companyService.actions,
  ...globalconfigService.actions,
  ...billingService.actions,
  ...userdataService.actions,
  ...manualcleansingService.actions,
  ...newsfeedmasterService.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }